// extracted by mini-css-extract-plugin
module.exports = {"content":"LoginPanel_content__3skYD","form":"LoginPanel_form__3vnI-","heading":"LoginPanel_heading__JpJUp","button":"LoginPanel_button__1jppf"};